import * as angular from 'angular';
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {$teamsFactory} from "../../$teams.factory";

export class TeamsDisplayListComponent implements IController {
  ids: any;
  isRow: any;
  rowLimit: any;
  onChange: Function;

  public teamsRef: any;
  public displayItems: any;

  /* @ngInject */
  constructor(private $teams: $teamsFactory, private $log) {

  }
  $onInit() {
    this.teamsRef = this.$teams();

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.teamsRef.$asyncValues(ids)
        .then((teams) => {
          const displayItems = [];
          _.forEach(teams, (a) => {
            displayItems.push({id: a.id, value: a.name})
          })
          this.displayItems = displayItems;
        })
        .catch((error) => {
          this.$log.error('Failed to get branches', error);
        })
    } else {
      this.displayItems = [];
    }
  }


}

angular
  .module('bringoz.admin.teams')
  .component('teamsDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./teams-display-list.html').default,
    controller: TeamsDisplayListComponent
  });
